<template>
  <div>
    <div
      class="options-wrapper"
      v-for="type in options"
      :key="type.name"
    >
      <p v-if="!hideName" class="options-name">{{ type.name }}</p>

      <div class="options">
        <div
          v-for="option in type.options"
          class="options__option"
          @click="submitForm(option.html, {
            requiresDeviceLink: type.requires_device_link,
            showInformationShareWarning: type.show_information_share_warning
          })"
          :key="option.name"
        >
          <p class="options__time">{{ option.name }}</p>
          <p class="options__price">{{ option.price }}</p>
        </div>
      </div>

      <html-with-links tag="div" class="tip"
                       :html="$t('SIDELOADING_OPTIONS_TIP',{href:'/my/plus'})">
      </html-with-links>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import isItselfLinkable from '@/utils/isItselfLinkable';
import HtmlWithLinks from '@/components/HtmlWithLinks.vue';

export default {
  components: { HtmlWithLinks },
  props: {
    options: Array,
    hideName: Boolean,
  },
  computed: {
    ...mapGetters(['isDeviceLinked', 'config', 'devices', 'lt']),
    currentDevice() {
      return this.devices.find(d => d.lt === this.lt) || {};
    },
  },
  methods: {
    checkDeviceLinkingForPurchase() {
      if (!this.isDeviceLinked) {
        this.$confirm(this.$t('LINKED_DEVICE_REQUIRED'))
          .then(() => {
            this.$router.push('/link');
          })
          .catch(() => {
          });
      }

      return this.isDeviceLinked;
    },
    async submitForm(html, {
      requiresDeviceLink,
      showInformationShareWarning
    } = {}) {
      const div = document.createElement('div');
      div.style.display = 'none';
      div.innerHTML = html;
      document.body.appendChild(div);
      const form = div.firstChild;

      if (!requiresDeviceLink) {
        form.submit();
        return;
      }

      if (!this.checkDeviceLinkingForPurchase()) {
        return;
      }

      if (showInformationShareWarning) {
        await this.$confirm(this.$t('IMPORT_DEV_CREDENTIALS_PROVIDER_CONFIRMATION'));
      }

      this.$confirm(`${this.$t('IS_CORRECT_DEVICE')} ${this.currentDevice.name} - ${this.currentDevice.model}?`)
        .then(() => form.submit())
        .catch(() => {
          if (this.devices.length > 1) {
            return this.$confirm(this.$t('SWITCH_TO_ANOTHER_DEVICE_REDIRECT'))
              .then(() => {
                this.$router.push('/my/devices');
              });
          }

          return Promise.reject();
        })
        .catch(() => this.$confirm(this.$t('DO_YOU_WANT_LINK_ANOTHER_DEVICE'))
          .then(() => {
            this.$router.push('/my/devices');
          }))
        .catch(() => {
          if (!isItselfLinkable()) {
            this.$notify({
              type: 'error',
              text: this.$t('VISIT_FROM_IDEVICE'),
            });
            return;
          }

          this.$notify({
            type: 'success',
            text: this.$t('ORPHANED_LINK_DESC'),
          });

          this.$api.getLinkCode()
            .then((code) => {
              this.$notify({
                type: 'success',
                text: this.$t('DEVICE_IS_BEING_LINKED_RELOAD'),
              });

              this.$store.commit('lt', '');
              this.$api.link({
                code,
                type: 'new'
              }, true)
                .then((data) => {
                  this.$store.commit('lt', data.link_token);
                  window.location = data.profile_service;
                });
            });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.options-wrapper {
  & + .options-wrapper {
    margin-top: 15px;
  }
}

.options-name {
  font-weight: 700;
  margin-bottom: 10px;
}

.options {
  display: flex;
  gap: 10px;

  @include tablet {
    gap: 5px;
  }

  &__option {
    flex-grow: 1;
    border-radius: 8px;
    padding: 15px;
    background-image: $my-buy-options-gradient;
    color: #fff;
    font-weight: 500;
    text-align: center;
    cursor: pointer;

    @include tablet {
      padding: 10px;
    }
  }

  &__time {
    font-size: 16px;
    margin-bottom: 5px;

    @include tablet {
      font-size: 14px;
    }
  }

  &__price {
    font-size: 20px;
    white-space: nowrap;

    @include tablet {
      font-size: 14px;
      font-weight: 700;
    }
  }
}

.tip {
  font-size: 12px;
  margin-top: 5px;
}
</style>
